<template>
  <transition name="pc-select-store-fade">
    <div v-if="self.isShow" class="pc-select-store__mask">
      <div class="pc-select-store">
        <div class="pc-select-store__header">
          <div class="pc-select-store__title">请选择门店</div>
          <!-- <div class="pc-select-store__close P-Cursor" @click="handleClose">×</div> -->
        </div>

        <div class="pc-select-store__search">
          <PcInput
            v-model="searchKeyword"
            leftTitle="门店名称/简称"
            placeholder="请输入"
            clearable
          />
        </div>

        <el-scrollbar class="pcpr16">
          <div class="pc-select-store__list">
            <div
              class="pc-select-store__item"
              v-for="(clinicItem, clinicIndex) in filteredClinicList"
              :key="clinicIndex"
              @click="handleSelectClinic(clinicItem)"
            >
              <div class="pc-select-store__info">
                <div class="pc-select-store__label">名称</div>
                <div class="pc-select-store__value">
                  {{ clinicItem.clinicName }}
                </div>
              </div>
              <div class="pc-select-store__info">
                <div class="pc-select-store__label">简称</div>
                <div class="pc-select-store__value">
                  {{ clinicItem.abbreviation }}
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </transition>
</template>

<script>
import PinyinMatch from "pinyin-match";

export default {
  name: "PcSelectStore",
  props: {
    self: {
      type: Object,
      default: () => ({
        isShow: false,
      }),
    },
    clinicList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchKeyword: "",
    };
  },
  computed: {
    filteredClinicList() {
      const keyword = this.searchKeyword.trim();
      if (!keyword) return this.clinicList;
      return this.clinicList.filter(
        (item) =>
          PinyinMatch.match(item.clinicName || "", keyword) ||
          PinyinMatch.match(item.abbreviation || "", keyword),
      );
    },
  },
  methods: {
    /**
     * 预留门店选择方法，后续接入实际功能
     * @param {Object} clinicItem - 当前点击的门店数据
     */
    handleSelectClinic(clinicItem) {
      this.$emit("selectClinic", clinicItem);
    },
    /**
     * 关闭弹窗
     */
    handleClose() {
      this.self.isShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.pc-select-store__mask {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  padding: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 999;
}

.pc-select-store {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: #fff;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
}

.pc-select-store__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #e6e6e6;
}

.pc-select-store__title {
  color: #333333;
  font-size: 18px;
}

.pc-select-store__search {
  width: 300px;
  padding: 12px 0 4px 0;
}

.pc-select-store__list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding-right: 4px;
  overflow-y: auto;
  padding-top: 10px;
  padding-bottom: 10px;
}

.pc-select-store__item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: calc(25% - 9px);
  min-width: 240px;
  padding: 16px 12px;
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  gap: 12px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pc-select-store__info {
  display: flex;
  width: 100%;
}

.pc-select-store__label {
  margin-right: 16px;
  color: #666666;
  flex-shrink: 0;
}

.pc-select-store__value {
  flex: 1;
  width: 0;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.pc-select-store-fade-enter-active,
.pc-select-store-fade-leave-active {
  transition: opacity 0.2s ease;
}

.pc-select-store-fade-enter,
.pc-select-store-fade-leave-to {
  opacity: 0;
}
</style>
